import {action} from 'mobx';

import {EXPIRES_IN, EXPIRES_PENDING, EXPIRE_TIME} from '../../../constants/storeConstants';
import {STATE_FULFILLED, STATE_PENDING, STATE_REJECTED} from '../../../constants/asyncConstants';
import serverApi from '../../../utils/serverApi';
import ApiBaseStore from '../common/apiBaseStore';

/**
 * ApiTargetedCampaignGetAllStore
 */
class ApiTargetedCampaignGetAllStore extends ApiBaseStore {
  /**
   * Fetches all targeted campaigns for the currently logged in user.
   *
   * @param {string} app
   * @param {string|undefined} planId
   */
  @action makeRequest(app, planId) {
    this.state = STATE_PENDING;
    this[EXPIRE_TIME] = Date.now() + EXPIRES_PENDING;

    serverApi.targetedCampaignsGetAll(app, planId)
      .then(action('targetedCampaignsGetAllSuccess', (targetedCampaigns) => {
        this.state = STATE_FULFILLED;
        this[EXPIRE_TIME] = Date.now() + EXPIRES_IN;
        this.data = targetedCampaigns;
        this.error = null;
      })).catch(action('targetedCampaignsGetAllError', (targetedCampaignsGetAllError) => {
        this.state = STATE_REJECTED;
        this[EXPIRE_TIME] = null;
        this.data = null;
        this.error = targetedCampaignsGetAllError;
      }));
  }
}

export default new ApiTargetedCampaignGetAllStore();
